export default __webpack_public_path__ + "static/media/unossl.316fa05d.gif";